export default __webpack_public_path__ + "static/media/mirkka-and-ozz-ellipse.78da0940.png";